import { ActionIcon, Menu, Text } from "@marketplace/ui";
import { useNavigate } from "@tanstack/react-router";
import { useSetAtom } from "jotai";
import { useTranslation } from "react-i18next";
import { MdMoreVert } from "react-icons/md";

import { automationDeleteModalAtom } from "../../atoms/automation-delete-modal-atom";
import { automationSetupNotifyModalAtom } from "../../atoms/automation-setup-notify-modal-atom";
import type { AutomationListItem } from "../../types";

type AutomationListTableActionsProps = {
  automation: AutomationListItem;
};

export const AutomationListTableActions = ({
  automation
}: AutomationListTableActionsProps) => {
  const { t } = useTranslation("product", {
    keyPrefix: "automation.listPage.tableActions"
  });
  const navigate = useNavigate();
  const setDeleteModal = useSetAtom(automationDeleteModalAtom);
  const setSetupNotifyModal = useSetAtom(automationSetupNotifyModalAtom);

  return (
    <Menu width={120} position="bottom-end">
      <Menu.Target>
        <ActionIcon variant="transparent" className="text-fjord-grey-500">
          <MdMoreVert size={24} />
        </ActionIcon>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Item
          classNames={{
            item: "!p-0"
          }}
        >
          <Text
            component="a"
            size="s"
            className="p-[14px] block text-fjord-grey-500 cursor-pointer"
            onClick={() =>
              navigate({
                to: "/products/automation/$slug/edit",
                params: { slug: automation.id }
              })
            }
          >
            {t("edit")}
          </Text>
        </Menu.Item>

        <Menu.Item
          onClick={() => setDeleteModal({ visible: true, automation })}
        >
          <Text size="s" className="text-fjord-grey-500">
            {t("delete")}
          </Text>
        </Menu.Item>

        <Menu.Item
          onClick={() => setSetupNotifyModal({ visible: true, automation })}
        >
          <Text size="s" className="text-fjord-grey-500">
            {t("setupNotify", "Setup Notify")}
          </Text>
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};
